import { render, staticRenderFns } from "./payment_methods.vue?vue&type=template&id=10558474&scoped=true&"
import script from "./payment_methods.vue?vue&type=script&lang=js&"
export * from "./payment_methods.vue?vue&type=script&lang=js&"
import style0 from "./payment_methods.vue?vue&type=style&index=0&id=10558474&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10558474",
  null
  
)

export default component.exports